import React, { forwardRef } from "react";
import propTypes from "prop-types";
import Images from "assets/images/imageData";

const labelInput = forwardRef(
  (
    {
      type = "text",
      value = "",
      onChange,
      label,
      errorMsg = null,
      className = "",
      onFocus,
      onBlur,
      onKeyUp,
      onInput,
      maxLength,
      max,
      min,
      minLength,
      disabled = false,
      required = false,
      isError = false,
      name,
      fullWidth = false,
      pattern,
      icon = null,
      isFilled = false,
      suggestion = null,
      verified = false,
      placeholder = "",
      readonly = "",
      password = null,
      onClick,
      showpassword = false,
      autoComplete = "off",
      button = false,
      buttonText = "",
      onButtonClick,
      isIcon = false,
      onPaste,
      onCopy,
      preData,
      ...rest
    },
    ref
  ) => (
    <div
      className={`form-group ${isIcon ? "" : "icon-group"} ${
        isError ? "error-text" : ""
      }`}
    >
      {icon !== null ? (
        <span className="icon">
          <img src={icon} alt="" />
        </span>
      ) : null}
      <input
        type={type}
        ref={ref}
        className={`form-control ${className} ${isFilled ? "" : "empty"}`}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyUp={onKeyUp}
        onInput={onInput}
        onPaste={onPaste}
        onCopy={onCopy}
        maxLength={maxLength}
        max={max}
        min={min}
        minLength={minLength}
        disabled={disabled ? "disabled" : ""}
        required={required ? "required" : ""}
        readOnly={readonly}
        name={name}
        pattern={pattern}
        placeholder={placeholder}
        autoComplete={autoComplete}
        autoCorrect="off"
        {...rest}
      />

      <label className="placeholder">
        {label}
        {required ? <b className="required__fields">*</b> : null}
      </label>
      {preData ? <span className="pre-data">{preData}</span> : null}
      {suggestion !== null ? (
        <span className="help-text">{suggestion}</span>
      ) : null}
      {verified ? (
        <span className="verified d-block" onClick={onClick}>
          <React.Fragment>
            {password ? (
              <img
                src={showpassword ? Images?.eyeIcon : Images?.openEyeicon}
                alt=""
              />
            ) : (
              <img
                src={isError ? Images?.alertCircle : Images?.verified}
                alt=""
              />
            )}
          </React.Fragment>
        </span>
      ) : null}
      {!!button ? (
        <div
          role="button"
          tabIndex={0}
          className="verified"
          onClick={onButtonClick}
        >
          <button className="btn btn-primary btn-sm">{buttonText}</button>
        </div>
      ) : null}
    </div>
  )
);

labelInput.propTypes = {
  type: propTypes.oneOfType([propTypes.object, propTypes.string]),
  value: propTypes.oneOfType([
    propTypes.object,
    propTypes.string,
    propTypes.number,
  ]),
  onChange: propTypes.func,
  label: propTypes.oneOfType([propTypes.string, propTypes.object]),
  errorMsg: propTypes.oneOfType([propTypes.string, propTypes.object]),
  name: propTypes.oneOfType([propTypes.string, propTypes.object]),
};

export default labelInput;
